import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { projectOfInterestData } from "../../utils/ProjectOfInterestData";
import ShowVulnerabilityContent from "./ShowVulnerabilityContent";
import MKBox from "../../components/MKBox";
import routes from "../../routes";
import DefaultNavbar from "../../components/Navbars/DefaultNavbar";

export const fetchOsspoiMaterData = async () => {
  const osspoi: any = JSON.parse(
    await projectOfInterestData.getJsonReportOsspoiMaster()
  );
  projectOfInterestData.updateDataPoi("Project_of_interest", osspoi.items);
  return osspoi;
};

function ShowVulnerabilityDetails() {
  return (
    <>
      <DefaultNavbar routes={ routes } sticky />
      <MKBox pt={ 14 } sx={ { mx: { xs: 2, lg: 3 } } }>
        <Grid container spacing={ 6 }>
          <Grid item xs={ 12 }>
            <Card>
              <MKBox pt={ 3 } px={ 3 }>
                <ShowVulnerabilityContent />
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
    </>
  );
}

export default ShowVulnerabilityDetails;
